import CardType from "@app/enum/dashboard/CardType";
import activitiesLoggedCard from "@app/scene/dashboard/components/cards/ActivitiesLogged";
import activitiesOverdueCard from "@app/scene/dashboard/components/cards/ActivitiesOverdue";
import checkInsCard from "@app/scene/dashboard/components/cards/CheckIns";
import closedStageDealAmountCard from "@app/scene/dashboard/components/cards/ClosedStageDealAmount";
import closedStageDealCountCard from "@app/scene/dashboard/components/cards/ClosedStageDealCount";
import customerFaceTimeCard from "@app/scene/dashboard/components/cards/CustomerFaceTime";
import mileageTrackingCard from "@app/scene/dashboard/components/cards/MileageTracking";
import newRecordsCard from "@app/scene/dashboard/components/cards/NewRecord";
import newRoutesCard from "@app/scene/dashboard/components/cards/NewRoutes";
import noContactInCard from "@app/scene/dashboard/components/cards/NoContactIn";
import noContactInCountCard from "@app/scene/dashboard/components/cards/NoContactInCount";
import openStageDealAmountCard from "@app/scene/dashboard/components/cards/OpenStageDealAmount";
import outOfFrequencyCard from "@app/scene/dashboard/components/cards/OutOfFrequency";
import recordsPastDueCard from "@app/scene/dashboard/components/cards/RecordsPastDue";
import upcomingActivitiesCard from "@app/scene/dashboard/components/cards/UpcomingActivities";
import CardUiDescriptor from "@app/scene/dashboard/types/CardUiDescriptor";

const cardTypeToCard: Record<CardType, CardUiDescriptor<any>> = {
  [CardType.ACTIVITIES_LOGGED]: activitiesLoggedCard,
  [CardType.ACTIVITIES_OVERDUE]: activitiesOverdueCard,
  [CardType.CHECK_INS]: checkInsCard,
  [CardType.CLOSED_STAGE_DEAL_AMOUNT]: closedStageDealAmountCard,
  [CardType.CLOSED_STAGE_DEAL_COUNT]: closedStageDealCountCard,
  [CardType.CUSTOMER_FACE_TIME]: customerFaceTimeCard,
  [CardType.MILEAGE_TRACKING]: mileageTrackingCard,
  [CardType.NEW_RECORDS]: newRecordsCard,
  [CardType.NEW_ROUTES]: newRoutesCard,
  [CardType.NO_CONTACT_IN]: noContactInCard,
  [CardType.NO_CONTACT_IN_COUNT]: noContactInCountCard,
  [CardType.OPEN_STAGE_DEAL_AMOUNT]: openStageDealAmountCard,
  [CardType.OUT_OF_FREQUENCY]: outOfFrequencyCard,
  [CardType.RECORDS_PAST_DUE]: recordsPastDueCard,
  [CardType.UPCOMING_ACTIVITIES]: upcomingActivitiesCard,
} as const;

const getCardByType = <T extends CardType>(type: T): (typeof cardTypeToCard)[T] =>
  cardTypeToCard[type];

export default getCardByType;
